import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { ApiManager } from "./api/ApiManager";
import {useApplicationStore} from "./applicationStore";

export const useFlashNewsStore = defineStore('flashNewsStore',
  () => {
    const applicationStore = useApplicationStore();
    const userDetails = computed(() => applicationStore.userDetails || false);
    const storeCategories = {
      [userDetails.value.id]: {
        flash_news: {},
      }
    };

    const options = {
      apiManager: new ApiManager('flash-news'),
      readonly: true,
      sync: true,
      allTime: false,
      persistentLocalId: false
    }
    const data = ref(storeCategories);

    const flashNews = computed(() => data.value[userDetails.value.id]?.flash_news || {});

    return {
      data,
      options,
      flashNews,
    }
  },
  {
    persistedState: {
      overwrite: true
    }
  }
);